function estimate(state = {
  estimate: [],
  fetching: false,
  fetched: false,
  error: null,

}, action){
  switch (action.type) {
      case 'GET_ESTIMATE_FULFILLED':{
        return{
          ...state,
          fetched:true,
          estimate: action.payload,
          fetching: false,
          error:null,
        }
      }
      case 'GET_ESTIMATE_REJECTED':{
        return {
          ...state,
          fetched:false,
          fetching: false,
          error: action.payload,
        }
      }
      case 'GET_ESTIMATE_CALCULATING':{
        return {
          ...state,
          fetching: true,
        }
      }
      case 'CLEAR_ESTIMATE':{
        return {
          ...state,
          fetched:false,
          estimate:[],
          error:null
        }
      }
        default: break
   }
   return state;
}
export default estimate;



/** WEBPACK FOOTER **
 ** ./src/reducers/estimate.js
 **/